import React, { useRef } from 'react'
import { Button } from 'antd';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type JsonFileUploadProps<T = any> = {
  updateFormWithJson: (jsonData: T) => void
  label?: string
}

export const JsonFileUpload: React.FC<JsonFileUploadProps> = ({
  updateFormWithJson,
  label = 'Import',
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  // Triggers upload everytime
  const key = Date.now()

  const onFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const fileContents = e.target?.result as string
        const jsonData = JSON.parse(fileContents)

        updateFormWithJson(jsonData)
      }
      reader.readAsText(file)
    }
  }

  return (
    <>
      <Button onClick={() => fileInputRef.current?.click()} type="primary">{label}</Button>
      <input
        type="file"
        accept=".json"
        ref={fileInputRef}
        key={key}
        hidden
        style={{ display: 'none' }}
        onChange={onFileUpload}
      />
    </>
  )
}
